import React, { useState } from "react";
import estilo from "./styles/Menu.module.css";
import { Link } from "react-router-dom";

function Menu() {
  const [sidebar, setSidebar] = useState(false);
  const showSidebar = () => setSidebar(!sidebar);

  return (
    <div className={estilo.menu_principal}>
      <div className={estilo.menu_header}>
        <div className={estilo.menu_logo}>
          <Link to="/">
            <h1>
              <em>yTAnime</em>
              <b>TV</b>
            </h1>
          </Link>
        </div>

        <div className={estilo.menu}>
          <div
            className={
              sidebar
                ? `${estilo.barra_icono} ${estilo.cambiar}`
                : estilo.barra_icono
            }
            onClick={showSidebar}
          >
            <div className={estilo.barra_a}></div>
            <div className={estilo.barra_b}></div>
            <div className={estilo.barra_c}></div>
          </div>

          <ul
            className={
              sidebar ? `${estilo.lista} ${estilo.activar_menu}` : estilo.lista
            }
          >
            <li>
              <Link to="/" onClick={showSidebar}>
                Inicio
              </Link>
            </li>
            <li>
              <Link to="/animes" onClick={showSidebar}>
                Animes
              </Link>
            </li>
            <li>
              <Link to="/buscar" onClick={showSidebar}>
                Buscar
                <svg fill="currentColor" viewBox="0 0 16 16">
                  <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                </svg>
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <div
        className={sidebar ? `${estilo.fondo}` : ""}
        onClick={showSidebar}
      ></div>
      <div className={estilo.solido}></div>
    </div>
  );
}

export default Menu;
